/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL, { FlyToInterpolator } from 'react-map-gl';
import {json as requestJson} from 'd3-request';
import * as d3 from 'd3-ease'
import {fromJS} from 'immutable';
import _ from 'lodash';
import WebMercatorViewport from 'viewport-mercator-project';
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase';
import { Loader } from 'semantic-ui-react';
import ControlPanel from './control-panel';
import Notifications from './notifications';
import { getLineFeaturesForAnimation } from './utils';
import {defaultMapStyle, unclusteredLayer} from './map-style.js';
import { MAPBOX_TOKEN } from '../../../config/tokens'

export default class App extends Component {

  state = {
    mapStyle: '',
    loading: true,
    viewport: {
      latitude: 39.1098747253418,
      longitude: -84.50493621826172,
      zoom: 1,
      bearing: 0,
      pitch: 0,
      width: 500,
      height: 500,
      maxZoom: 17,
      minZoom: 1,
    },
    notifications: [],
    sessions: {},
    featureCounter: 0,
    coordinateCounter: 0,
    showControlPanel: false,
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
    if(this.state.loading && isLoaded(this.props.sessions))
      this._loadFirebaseData();
  }

  componentDidUpdate(prevProps) {
    if(this.state.loading && isLoaded(this.props.sessions))
      this._loadFirebaseData();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  _loadFirebaseData = () => {
    const { sessions, sessionKey } = this.props;
    if(!sessions[sessionKey])
      this.setState({loading: false,mapStyle: defaultMapStyle});
    else
      this._loadData(sessions);
  }

  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: this.props.width || window.innerWidth,
        height: this.props.height || window.innerHeight
      }
    });
  };

  // LOAD DATA

  _loadData = firebaseData => {

    const lineFeaturesForAnimation = getLineFeaturesForAnimation(firebaseData);
    const flatLines = _.flatten(lineFeaturesForAnimation.featuresCoordinates)

    var lines = {
      "type": "FeatureCollection",
      "features": lineFeaturesForAnimation.emptyFeatures
    };

    const newMapStyle = defaultMapStyle
      .setIn(['sources', 'lines'], fromJS({type: 'geojson',data: lines}));

    // DATA IS LOAED,
    this.setState({
      mapStyle: newMapStyle,
      loading: false,
      emptyFeatures: lineFeaturesForAnimation.emptyFeatures,
      featuresCoordinates: lineFeaturesForAnimation.featuresCoordinates,
      originCoordinates: lineFeaturesForAnimation.originCoordinates,
      flatLines,
    });
  };

  _initializeMapPosition = () => {
    const { originCoordinates } = this.state

    if(!originCoordinates)
      return;

    this._onViewportChange({
      width: this.props.width || window.innerWidth,
      height: this.props.height || window.innerHeight,
      longitude: originCoordinates[0],
      latitude: originCoordinates[1],
      zoom: 13,
      // transitionInterpolator: new FlyToInterpolator(),
      // transitionDuration: duration,
      // transitionEasing: d3.easeCubicIn,
    });
    // this._flyToDrawing();
    this._startAnimation();
  }

  _flyToDrawing = () => {

    // const {longitude, latitude, zoom} = new WebMercatorViewport(this.state.viewport)
    //         .fitBounds(this.state.flatLines , {
    //           padding: 200,
    //           offset: [10, 0]
    //         });
    //         console.log('zoom',zoom)
        const viewport = {
            ...this.state.viewport,
            zoom: 13,
            transitionDuration: 3000,
            transitionInterpolator: new FlyToInterpolator(),
            transitionEasing: d3.easeCubic,
            onTransitionEnd: this._startAnimation
        }
        this.setState({viewport});


  }

  _zoomOut = () => {

        const viewport = {
            ...this.state.viewport,
            zoom: 3,
            transitionDuration: 5000,
            transitionInterpolator: new FlyToInterpolator(),
            transitionEasing: d3.easeCubic,
        }
        this.setState({viewport});
  }

  _startAnimation = () => {
    // console.log('start')
    this._animate();
  }


  _animate = () => {

    const { emptyFeatures, mapStyle, animationCounter, featuresCoordinates, featureCounter, coordinateCounter } = this.state
    // console.log(this.state)
    setTimeout( () => {

      const newMapStyle = mapStyle
        // .updateIn(['sources', 'lines', 'data', 'features', featureCounter, 'geometry', 'coordinates'], coordinates => coordinates.concat(featuresCoordinates[featureCounter]));
        .setIn(['sources', 'lines', 'data', 'features', featureCounter, 'geometry', 'coordinates', coordinateCounter],  featuresCoordinates[featureCounter][coordinateCounter] );


      if (coordinateCounter < featuresCoordinates[featureCounter].length - 1) {
        // then we are still drawing a line, continue
        this.setState({
          mapStyle: newMapStyle,
          coordinateCounter: coordinateCounter + 1,
        });
        requestAnimationFrame(this._animate);

      } else if (featureCounter < emptyFeatures.length - 1) {
        // then we finished drawings a line, now start  the next line
        this.setState({
          mapStyle: newMapStyle,
          coordinateCounter: 0,
          featureCounter: featureCounter + 1,
        });
        requestAnimationFrame(this._animate);

      } else {
        this.setState({showControlPanel: true})
      }

}, 30 );

  }


  _onViewportChange = viewport => {
    this.setState({
      viewport: {...this.state.viewport, ...viewport},
    });
  }

  _onMapHover = event => {
    // console.log(event)
  }

  _onMapClick = event => {

  }

  _onMapLoad = event => {
    this.map = this.mapRef.getMap()
    // this._onMapMove();
    // event.target.on('move', this._onMapMove );

    // adding this so we have state data
    this._initializeMapPosition();

  }


  render() {
    const {viewport, mapStyle, loading} = this.state;

    if(loading)
      return <Loader active />


    return (
      <div>
      <MapGL
        ref={(el) => this.mapRef = el}
        {...viewport}
        mapStyle={mapStyle}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        onHover={this._onMapHover}
        onClick={this._onMapClick}
        onLoad={this._onMapLoad}
        >
      </MapGL>


      <Notifications onNotificationClick={this._onSessionClickFromNotification} {...this.state} />
      <ControlPanel {...this.state} zoomOut={this._zoomOut} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Hello/Map.js